export const PAYEE_PATIENT = "patient";
export const PAYEE_ORGANISATION = "organisation";

export const REGENERUS = "Regenerus";
export const REGENERUS_REGENCY = "Regenerus-Regency-API";
export const CYREX_API = "Cyrex-API";

/** Shown when the basket is multi-patient and the user tries to add a Cyrex base test. */
export const CYREX_BASE_UNAVAILABLE_FOR_MULTI_PATIENT_BASKET_MESSAGE =
  "Cyrex tests cannot be added to a multi-patient basket. Turn off multi-patient ordering first.";

export const CMP_PERMISSION_ADMIN = "ADMIN_ACCESS";

export const CMP_PERMISSION_VIEW_RESULTS = "RESULTS_VIEW";

export const CMP_PERMISSION_VIEW_PATIENTS = "PATIENTS_VIEW";
export const CMP_PERMISSION_ADD_PATIENTS = "PATIENTS_ADD";
export const CMP_PERMISSION_DELETE_PATIENTS = "PATIENTS_DELETE";
export const CMP_PERMISSION_EDIT_PATIENTS = "PATIENTS_EDIT";

export const CMP_PERMISSION_VIEW_PRACTITIONERS = "PRACTITIONERS_VIEW";
export const CMP_PERMISSION_ADD_PRACTITIONERS = "PRACTITIONERS_ADD";
export const CMP_PERMISSION_DELETE_PRACTITIONERS = "PRACTITIONERS_DELETE";

export const CMP_PERMISSION_VIEW_ORDERS = "ORDERS_VIEW";
export const CMP_PERMISSION_PLACE_ORDERS = "ORDERS_PLACE";
export const CMP_PERMISSION_CANCEL_ORDERS = "ORDERS_CANCEL";
export const CMP_PERMISSION_MULTIPATIENT_ORDERS = "ORDERS_MULTIPATIENT";
export const CMP_PERMISSION_STOCK_ORDERS = "ORDERS_STOCK";

export const CMP_PERMISSION_VIEW_STOCK = "STOCK_VIEW";
export const CMP_PERMISSION_REGISTER_STOCK = "STOCK_REGISTER";

export const CMP_PERMISSION_VIEW_COMMISSIONS = "COMMISSIONS_VIEW";
export const CMP_PERMISSION_VIEW_ACCOUNT_BALANCES = "ACCOUNT_BALANCES_VIEW";

export const CMP_PERMISSION_VIEW_ALL_ORDERS = "ORDERS_VIEW_ALL";
export const CMP_PERMISSION_VIEW_ALL_STOCK = "STOCK_VIEW_ALL";
export const CMP_PERMISSION_VIEW_ALL_PATIENTS = "PATIENTS_VIEW_ALL";
export const CMP_PERMISSION_VIEW_ALL_COMMISSIONS = "COMMISSIONS_VIEW_ALL";

export const CMP_PERMISSION_VIEW_SHOP = "SHOP_VIEW";
export const CMP_PERMISSION_PURCHASE_PRODUCTS = "PRODUCTS_PURCHASE";
export const CMP_PERMISSION_CHOOSE_PATIENT = "PATIENTS_CHOOSE";
export const CMP_PERMISSION_VIEW_SUPPORT = "SUPPORT_VIEW";

export const CMP_PERMISSION_STRIPE_ONBOARD = "STRIPE_ONBOARD";
export const CMP_PERMISSION_PATIENT_PAY = "PATIENTS_PAY";
export const CMP_PERMISSION_USE_PAYMENT_INVOICES = "PAYMENT_INVOICES_USE";
export const CMP_PERMISSION_CREATE_ORGANISATIONS = "ORGANISATIONS_CREATE";

// Appointment types
export const APPOINTMENT_TYPE_WHICH_TEST = "Which test?";
export const APPOINTMENT_TYPE_1_X_TEST_RESULT = "1 x Test Result";
export const APPOINTMENT_TYPE_2_X_TEST_RESULTS = "2 x Test Results";
export const APPOINTMENT_TYPE_REQUEST_CALLBACK = "Request callback";
export const APPOINTMENT_TYPE_FIRST_TEST_RESULTS = "First test results";

export const APPOINTMENT_TYPE_VALUES = [
  APPOINTMENT_TYPE_WHICH_TEST,
  APPOINTMENT_TYPE_1_X_TEST_RESULT,
  APPOINTMENT_TYPE_2_X_TEST_RESULTS,
  APPOINTMENT_TYPE_REQUEST_CALLBACK,
  APPOINTMENT_TYPE_FIRST_TEST_RESULTS
];
